











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaMedlog} from '@/model/resource/CargaMedlog'
import {CargaMedlogCollection} from '@/model/collection/CargaMedlogCollection'
import {ListCargaMedlogSchema} from '@/schema/resource/CargaMedlog/ListCargaMedlogSchema'
import {CsvCargaMedlogSchema} from '@/schema/resource/CargaMedlog/CsvCargaMedlogSchema'

@Component
export default class ListCargaMedlogView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaMedlogSchema()
  collection = new CargaMedlogCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaMedlog) {
    Helper.pushByName('editCargaMedlog', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaMedlogCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaMedlog()
    new CsvCargaMedlogSchema().downloadCsv(csv.all())
  }
}
